import CryptoJS from "crypto-js";
import axiosClient from "../api-client/AxiosClient";

let sessionAESKey = null;
let keyFetchPromise = null; // Cache the fetch promise to avoid race conditions

// Fetch key from backend API
export async function fetchAESKey() {
  // If already fetched, return it
  if (sessionAESKey) {
    return sessionAESKey;
  }

  // If currently fetching, wait for it to complete
  if (keyFetchPromise) {
    return keyFetchPromise;
  }

  // Fetch the key
  keyFetchPromise = (async () => {
    try {
      const res = await axiosClient.get("/api/MappingDB/GetEncryptionKey");
      
      // axiosClient already handles response as JSON
      const data = res.data || res;
      
      // Your API returns 'aesKey' not 'key'
      const key = data.aesKey || data.key;
      if (!key) {
        throw new Error("No encryption key received from server");
      }
      
      sessionAESKey = key;
      return sessionAESKey;
    } catch (error) {
      console.error("Error fetching AES key:", error);
      keyFetchPromise = null; // Reset so we can retry
      throw error;
    }
  })();

  return keyFetchPromise;
}

// Encrypt a text using the fetched AES key
export function encryptText(text) {
  if (!sessionAESKey) {
    throw new Error("AES key not loaded. Call fetchAESKey() first.");
  }
  
  if (!text || text === "") {
    return ""; // Return empty string for empty input
  }
  
  try {
    // Convert text to string if it's not already
    const textToEncrypt = String(text);
    
    // Encrypt with proper encoding
    const encrypted = CryptoJS.AES.encrypt(textToEncrypt, sessionAESKey);
    
    // Return the encrypted data as a string
    return encrypted.toString();
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error(`Failed to encrypt text: ${error.message}`);
  }
}

// Check if key is loaded
export function isKeyLoaded() {
  return sessionAESKey !== null;
}

// Clear the key (useful for logout)
export function clearEncryptionKey() {
  sessionAESKey = null;
  keyFetchPromise = null;
}